import { IGetRecommendationsNearNewbuildingResponse } from 'shared/common/repositories/newbuilding-search/v1/get-recommendations-near-newbuilding';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectSimilarNewbuildingsApiResult(
  state: TApplicationState,
): IGetRecommendationsNearNewbuildingResponse | null {
  return state.similarNewbuildings.data;
}
